"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactTransitionGroup = require("react-transition-group");
var _mobxReact = require("mobx-react");
var _invoke = _interopRequireDefault(require("lodash/invoke"));
var _find = _interopRequireDefault(require("lodash/find"));
var _get = _interopRequireDefault(require("lodash/get"));
var _stringUtils = require("../../../../utils/string-utils");
var _instructionUtils = require("../../../../utils/instruction-utils");
var _CloudinaryPictureWithControls = _interopRequireDefault(require("../../../CloudinaryPictureWithControls"));
var _ChecklistIndicatorIcons = _interopRequireDefault(require("../../../ChecklistIndicatorIcons"));
var _ToolbarItem = _interopRequireDefault(require("./ToolbarItem"));
var _styles = require("./styles");
var _dec, _class, _ToolbarComponent; //lodash
//helpers
//components
//styled-components
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var messages = (0, _reactIntl.defineMessages)({
  tip: {
    "id": "toolbar_title_tip",
    "defaultMessage": "Tip"
  },
  warning: {
    "id": "toolbar_title_warning",
    "defaultMessage": "Warning"
  },
  custom: {
    "id": "toolbar_title_custom",
    "defaultMessage": "Alternative"
  },
  fix: {
    "id": "toolbar_title_fix",
    "defaultMessage": "Fix"
  }
});
var ToolbarComponent = (_dec = (0, _mobxReact.inject)('store'), _dec(_class = (_ToolbarComponent = /*#__PURE__*/function (_Component) {
  function ToolbarComponent() {
    var _this;
    _classCallCheck(this, ToolbarComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ToolbarComponent, [].concat(args));
    _defineProperty(_this, "handleBackgroundClick", function () {
      _this.propagateToggle({
        type: null,
        trackAction: 'closeHintByBackground'
      });
    });
    _defineProperty(_this, "handleHintToggle", function (_ref) {
      var type = _ref.type;
      var selectedType = _this.props.selectedType;
      if (type === selectedType) {
        _this.propagateToggle({
          type: null,
          trackAction: 'closeHintByButton'
        });
      } else {
        _this.propagateToggle({
          type: type
        });
      }
    });
    _defineProperty(_this, "propagateToggle", function (_ref2) {
      var type = _ref2.type,
        trackAction = _ref2.trackAction;
      (0, _invoke["default"])(_this.props, 'onToggle', {
        type: type,
        trackAction: trackAction
      });
    });
    _defineProperty(_this, "shouldToolbarItemBeEnabled", function (key) {
      var _this$props = _this.props,
        notes = _this$props.notes,
        shouldAllToolbarItemsBeEnabled = _this$props.shouldAllToolbarItemsBeEnabled,
        store = _this$props.store,
        noteContentKey = _this$props.noteContentKey;
      var platform = store.platform;
      var canUseMediaInStepHints = platform.canUseMediaInStepHints;
      var noteContent = (0, _find["default"])(notes, {
        iconId: key
      });
      var hasContent = (0, _stringUtils.richTextHasValue)((0, _get["default"])(noteContent, noteContentKey));
      var hasImageUrl = canUseMediaInStepHints && (0, _get["default"])(noteContent, 'media.url');
      return shouldAllToolbarItemsBeEnabled || hasContent || hasImageUrl;
    });
    _defineProperty(_this, "selectedNote", function (iconId) {
      return (0, _find["default"])(_this.props.notes, {
        iconId: iconId
      });
    });
    _defineProperty(_this, "getIconLabel", function (icon) {
      var _this$props2 = _this.props,
        formatMessage = _this$props2.intl.formatMessage,
        currentLanguage = _this$props2.store.platform.currentLanguage;
      var type = icon.type,
        _icon$labelTranslatio = icon.labelTranslations,
        labelTranslations = _icon$labelTranslatio === void 0 ? [] : _icon$labelTranslatio;
      if (type !== _instructionUtils.stepNoteTypes.CUSTOM || !labelTranslations.length) {
        return formatMessage(messages[type.toLowerCase()]);
      }
      return (0, _instructionUtils.getCustomIconLabel)(labelTranslations, currentLanguage);
    });
    return _this;
  }
  _inherits(ToolbarComponent, _Component);
  return _createClass(ToolbarComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        getToolbarButtonStyle = _this$props3.getToolbarButtonStyle,
        hintContent = _this$props3.hintContent,
        imageSizes = _this$props3.imageSizes,
        isCheck = _this$props3.isCheck,
        selectedType = _this$props3.selectedType,
        shouldShowSpinnerWhileLoading = _this$props3.shouldShowSpinnerWhileLoading,
        store = _this$props3.store,
        noteContentKey = _this$props3.noteContentKey;
      var app = store.app,
        platform = store.platform;
      var icons = app.theme.icons;
      var canUseMediaInStepHints = platform.canUseMediaInStepHints,
        showStepNoteIconLabel = platform.showStepNoteIconLabel;
      var selectedNote = this.selectedNote(selectedType);
      var selectedIcon = (0, _find["default"])(icons, {
        id: selectedType
      });
      var selectedContent = (0, _get["default"])(selectedNote, noteContentKey);
      var selectedImageUrl = (0, _get["default"])(selectedNote, 'media.url');
      var selectedMetadata = (0, _get["default"])(selectedNote, 'media.metadata');
      var selectedNoteIsWarning = (0, _get["default"])(selectedIcon, 'type') === _instructionUtils.stepNoteTypes.WARNING;
      return /*#__PURE__*/_react["default"].createElement(_styles.ToolbarWrapper, null, hintContent ? hintContent : /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransitionGroup, {
        transitionName: "example",
        transitionEnterTimeout: 150,
        transitionLeaveTimeout: 150
      }, selectedType && /*#__PURE__*/_react["default"].createElement(_styles.ToolContent, null, /*#__PURE__*/_react["default"].createElement(_styles.Fader, {
        className: "fader",
        onClick: this.handleBackgroundClick
      }), /*#__PURE__*/_react["default"].createElement(_styles.StyledFadingOverflow, null, selectedNoteIsWarning && /*#__PURE__*/_react["default"].createElement(_styles.StyledNoteHeader, null, this.getIconLabel(selectedIcon)), /*#__PURE__*/_react["default"].createElement(_styles.Content, {
        className: "content"
      }, canUseMediaInStepHints && selectedImageUrl && /*#__PURE__*/_react["default"].createElement(_styles.ImageWrapper, null, /*#__PURE__*/_react["default"].createElement(_CloudinaryPictureWithControls["default"], {
        aspectRatio: 4 / 3,
        src: selectedImageUrl,
        metadata: selectedMetadata,
        sizes: imageSizes,
        shouldShowSpinnerWhileLoading: shouldShowSpinnerWhileLoading,
        shouldShowOverlayShapes: true
      })), /*#__PURE__*/_react["default"].createElement("div", {
        "data-cy": "hint-content",
        dangerouslySetInnerHTML: {
          __html: selectedContent
        }
      }))))), isCheck ? /*#__PURE__*/_react["default"].createElement(_styles.ChecklistIconWrapper, null, /*#__PURE__*/_react["default"].createElement(_ChecklistIndicatorIcons["default"], null)) : /*#__PURE__*/_react["default"].createElement(_styles.Toolbar, null, icons.map(function (icon) {
        return /*#__PURE__*/_react["default"].createElement(_ToolbarItem["default"], {
          key: icon.id,
          type: icon.type.toLowerCase(),
          iconId: icon.id,
          onToggle: _this2.handleHintToggle,
          isActive: selectedType === icon.id,
          label: showStepNoteIconLabel && _this2.getIconLabel(icon),
          themeIconUrl: icon.svg,
          isDisabled: !_this2.shouldToolbarItemBeEnabled(icon.id),
          getToolbarButtonStyle: getToolbarButtonStyle,
          isWarning: icon.type === _instructionUtils.stepNoteTypes.WARNING
        });
      })));
    }
  }]);
}(_react.Component), _defineProperty(_ToolbarComponent, "defaultProps", {
  notes: [],
  imageUrls: {},
  metadata: {},
  shouldAllToolbarItemsBeEnabled: false
}), _defineProperty(_ToolbarComponent, "propTypes", {
  getToolbarButtonStyle: _propTypes["default"].func,
  imageSizes: _propTypes["default"].string,
  isCheck: _propTypes["default"].bool.isRequired,
  onToggle: _propTypes["default"].func,
  selectedType: _propTypes["default"].string,
  shouldShowSpinnerWhileLoading: _propTypes["default"].bool
}), _ToolbarComponent)) || _class);
var _default = exports["default"] = (0, _reactIntl.injectIntl)(ToolbarComponent);
//# sourceMappingURL=index.js.map